import React, { useEffect } from 'react';
import mermaid from 'mermaid';

const Mermaid = ({ chart, mermaidRef }) => {
    useEffect(() => {
        mermaid.initialize({ startOnLoad: true });
        if (mermaidRef.current) {
            mermaidRef.current.innerHTML = `<div class="mermaid">${chart}</div>`;
            mermaid.contentLoaded();
        }
    }, [chart]);

    return <div ref={mermaidRef}></div>;
};

export default Mermaid;
